"use client";

import { usePathname } from "next/navigation";
import { useCareerStage } from "@/hooks/useCareerStage";
import { isHighSchoolLandingPath } from "@/lib/paths";

// 高校生は求人検索に到達しない（#1749）。求人と、その下流にあたる応募状況の
// 導線を出すかどうかの判定を、会員ヘッダ・画面下部のメニュー・ダッシュボード・
// マーケティング共通ヘッダで共有する。
//
// 判定の強さを2つに分けている:
// - 会員向け（ログイン済み前提）は「区分を確定できたユーザーだけに出す」
// - マーケティング向け（未ログインが大半）は「高校生と分かったときだけ出さない」
//   未ログインの新規訪問者は区分を持たないため、ここまで厳しくすると
//   トップページの求人導線が誰にも出なくなる。

function jobsFeatureEnabled(): boolean {
  return process.env.NEXT_PUBLIC_FEATURE_JOBS === "true";
}

/**
 * 会員向け（ヘッダー・画面下部のメニュー・ダッシュボード）の求人／応募状況の
 * 導線を出すか。
 *
 * 区分が未解決・取得失敗のときも出さない。判定が済む前に一瞬でも表示すると、
 * 高校生に求人を見せない決定に反する露出が起きる。
 */
export function useMemberJobsNavVisible(): boolean {
  const { careerStage } = useCareerStage();

  if (!jobsFeatureEnabled()) return false;
  if (careerStage === null) return false;
  return careerStage !== "high_school";
}

/**
 * マーケティング共通ヘッダ（TopHeader）の求人リンクを出すか。
 *
 * 高校生向けの案内ページ配下では、区分が確定していない初回訪問でも出さない。
 */
export function useMarketingJobsLinkVisible(): boolean {
  const pathname = usePathname();
  const { careerStage } = useCareerStage();

  if (!jobsFeatureEnabled()) return false;
  if (isHighSchoolLandingPath(pathname)) return false;
  return careerStage !== "high_school";
}
